module.exports = __webpack_public_path__ + "img/Old Winston and boys.3df919ae.jpg";